"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumReminders = void 0;
exports.EnumReminders = {
    None: 'None',
    OnTime: 'OnTime',
    _15MinBefore: '15MinBefore',
    _30MinBefore: '30MinBefore',
    _1HourBefore: '1HourBefore',
    _1DayBefore: '1DayBefore',
};
//# sourceMappingURL=enum-reminders.js.map